import { Account, Profile } from '@zapier/shared-entities';

export default function shouldRouteToStandaloneDashboard(state) {
  const currentAccount = Account.selectors.all.currentAccount(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return (
    // Opt-in wwitch is on for either account or profile
    (Profile.selectors.isSwitchOn('dashboard_next_opt-in', currentProfile) ||
      Account.selectors.isSwitchOn('dashboard_next_opt-in', currentAccount)) &&
    // AND opt-out switch is turned off for both account and profile
    !(
      Profile.selectors.isSwitchOn('dashboard_next_opt-out', currentProfile) ||
      Account.selectors.isSwitchOn('dashboard_next_opt-out', currentAccount)
    )
  );
}
